export default __webpack_public_path__ + "static/media/PPI-firefeature-017.a3766277.jpg";